export default "__VITE_ASSET__Bv4em1PK__"